/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNotificationCenterGetNotificationsGet } from '../fn/notification-center/api-notification-center-get-notifications-get';
import { ApiNotificationCenterGetNotificationsGet$Params } from '../fn/notification-center/api-notification-center-get-notifications-get';
import { apiNotificationCenterGetNotificationsGet$Plain } from '../fn/notification-center/api-notification-center-get-notifications-get-plain';
import { ApiNotificationCenterGetNotificationsGet$Plain$Params } from '../fn/notification-center/api-notification-center-get-notifications-get-plain';
import { apiNotificationCenterReadNotificationGet } from '../fn/notification-center/api-notification-center-read-notification-get';
import { ApiNotificationCenterReadNotificationGet$Params } from '../fn/notification-center/api-notification-center-read-notification-get';
import { apiNotificationCenterReadNotificationGet$Plain } from '../fn/notification-center/api-notification-center-read-notification-get-plain';
import { ApiNotificationCenterReadNotificationGet$Plain$Params } from '../fn/notification-center/api-notification-center-read-notification-get-plain';
import { GetUserNotificationsQueryResult } from '../models/get-user-notifications-query-result';
import { ReadNotificationCommandResult } from '../models/read-notification-command-result';

@Injectable({ providedIn: 'root' })
export class NotificationCenterService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNotificationCenterGetNotificationsGet()` */
  static readonly ApiNotificationCenterGetNotificationsGetPath = '/api/NotificationCenter/GetNotifications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNotificationCenterGetNotificationsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterGetNotificationsGet$Plain$Response(params?: ApiNotificationCenterGetNotificationsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserNotificationsQueryResult>> {
    return apiNotificationCenterGetNotificationsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNotificationCenterGetNotificationsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterGetNotificationsGet$Plain(params?: ApiNotificationCenterGetNotificationsGet$Plain$Params, context?: HttpContext): Observable<GetUserNotificationsQueryResult> {
    return this.apiNotificationCenterGetNotificationsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserNotificationsQueryResult>): GetUserNotificationsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNotificationCenterGetNotificationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterGetNotificationsGet$Response(params?: ApiNotificationCenterGetNotificationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserNotificationsQueryResult>> {
    return apiNotificationCenterGetNotificationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNotificationCenterGetNotificationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterGetNotificationsGet(params?: ApiNotificationCenterGetNotificationsGet$Params, context?: HttpContext): Observable<GetUserNotificationsQueryResult> {
    return this.apiNotificationCenterGetNotificationsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserNotificationsQueryResult>): GetUserNotificationsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNotificationCenterReadNotificationGet()` */
  static readonly ApiNotificationCenterReadNotificationGetPath = '/api/NotificationCenter/ReadNotification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNotificationCenterReadNotificationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterReadNotificationGet$Plain$Response(params?: ApiNotificationCenterReadNotificationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReadNotificationCommandResult>> {
    return apiNotificationCenterReadNotificationGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNotificationCenterReadNotificationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterReadNotificationGet$Plain(params?: ApiNotificationCenterReadNotificationGet$Plain$Params, context?: HttpContext): Observable<ReadNotificationCommandResult> {
    return this.apiNotificationCenterReadNotificationGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReadNotificationCommandResult>): ReadNotificationCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNotificationCenterReadNotificationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterReadNotificationGet$Response(params?: ApiNotificationCenterReadNotificationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReadNotificationCommandResult>> {
    return apiNotificationCenterReadNotificationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNotificationCenterReadNotificationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiNotificationCenterReadNotificationGet(params?: ApiNotificationCenterReadNotificationGet$Params, context?: HttpContext): Observable<ReadNotificationCommandResult> {
    return this.apiNotificationCenterReadNotificationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReadNotificationCommandResult>): ReadNotificationCommandResult => r.body)
    );
  }

}
